import { Checkbox } from '../Checkbox';
import { useTranslation } from 'react-i18next';
import { ChangeEvent } from 'react';
import { CheckBoxStateI } from 'app/hooks/useGetMapSettingsState';
import { FloatingComponent } from '../FloatingComponent';
import { useAppDispatch, useAppSelector } from 'app/store/store';
import { setShowAreaCard } from 'app/utils/marineInfrastructureReducer';

import styles from '../MapSettings/MapSetting.module.scss';

interface AreasInMapSettingsI {
    checkBoxSpecialAreasState: CheckBoxStateI;
}

export const AreasInMapSettings = ({checkBoxSpecialAreasState}: AreasInMapSettingsI) => {

    const {t} = useTranslation();
    const dispatch = useAppDispatch();
    const selectedArea = useAppSelector((state) => state.marineInfrastructureSlice.selectedArea);
    const mode = useAppSelector((state) => state.mapStateSlice.mode);
    const isAreasMode = mode === 'areas';

    const [
        [showECA, setShowECA],
        [showATBA, setShowATBA],
        [showNAVAREA, setShowNAVAREA],
        [showLLZ, setShowLLZ],
        [showEEZ, setShowEEZ],
    ] = [
        checkBoxSpecialAreasState.showECAState,
        checkBoxSpecialAreasState.showATBAState,
        checkBoxSpecialAreasState.showNAVAREAState,
        checkBoxSpecialAreasState.showLLZState,
        checkBoxSpecialAreasState.showEEZState,
    ];

    const handleAreasSettingsChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { value, checked } = e.target;
        localStorage.setItem(value, JSON.stringify(checked));
        if (value === 'showECA') {
            setShowECA(checked)
        } else if (value === 'showATBA') {
            setShowATBA(checked)
        } else if (value === 'showNAVAREA') {
            setShowNAVAREA(checked)
        } else if (value === 'showLLZ') {
            setShowLLZ(checked)
        } else if (value === 'showEEZ') {
            setShowEEZ(checked)
        }
        if (!isAreasMode && !checked && selectedArea?.subType && value.includes(selectedArea.subType)) {
            dispatch(setShowAreaCard(false));
        }
    };

    return (
      <FloatingComponent>
        <div className={styles.checkbox_group}>
            <Checkbox
                label={t('ECA')}
                value='showECA'
                className={styles.checkbox}
                checked={showECA}
                onChange={handleAreasSettingsChange}
            />
            <Checkbox
                label={t('ATBA')}
                value='showATBA'
                className={styles.checkbox}
                checked={showATBA}
                onChange={handleAreasSettingsChange}
            />
            <Checkbox
                label={'NAVAREA'}
                value='showNAVAREA'
                className={styles.checkbox}
                checked={showNAVAREA}
                onChange={handleAreasSettingsChange}
            />
            <Checkbox
                label={t('LLZ')}
                value='showLLZ'
                className={styles.checkbox}
                checked={showLLZ}
                onChange={handleAreasSettingsChange}
            />
            <Checkbox
                label={t('EEZ')}
                value='showEEZ'
                className={styles.checkbox}
                checked={showEEZ}
                onChange={handleAreasSettingsChange}
            />
        </div>
      </FloatingComponent >
    );
};
